module.exports = __webpack_public_path__ + "img/logo.669756fc.svg";